import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { html, TemplateResult } from 'lit';
import { WidgetStateFrontEnd } from '../../../../genericDashboard/gzGenericWidget/types';
import { styles } from '../view/styles';
import { WEB_COMPONENT_EASM_VULNERABLE_SERVICES } from '../../../../webcomponents.constants';
import { GzEasmGenericTopDataWebComponent } from '../../genericTopData';
import { query, property, customElement } from 'lit/decorators.js';
import { handleWidgetWithTopDataResize } from '../../../utils/utils';
import { translateFn } from '../../../../utils/translator.helper';
import { RowData } from '../../genericTopData/types/types';
import { MIN_NUMBER_OF_ROWS_TO_DISPLAY } from '../../constants';
import { EasmVulnerableServicesPayload } from '@nirvana/shared/dtos/types/widgets/common';
import { FilterType } from '../../genericTopData/types/types';
import { FindingClassType } from '../../../types';

@customElement(WEB_COMPONENT_EASM_VULNERABLE_SERVICES)
export class GzEasmVulnerableServicesWebComponent extends GzGenericWidgetContent {
  @property({
    type: WidgetStateFrontEnd,
    attribute: true,
    reflect: true,
  })
  state: WidgetStateFrontEnd;

  @property({
    type: Object,
    attribute: true,
    reflect: true,
  })
  payload: EasmVulnerableServicesPayload;

  // This is used for widget resize handle
  @query('gz-easm-generic-top-data')
  private gzEASMGenericTopData: GzEasmGenericTopDataWebComponent;

  static get styles() {
    return styles;
  }

  protected renderLoader(): TemplateResult {
    return html` <gz-loader rows="1" columns="1" style="margin-top: calc(var(--spacer) * 4)"></gz-loader> `;
  }

  protected renderContent(): TemplateResult {
    const data = this.payload?.easmVulnerableServices;
    const rowData: RowData[] = [];
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        rowData.push({ label: data[key].name, value: data[key].cvesLength.toString() });
      }
    }
    const numberOfObjectsDisplayed = Object.keys(rowData).length;
    const totalAssets = this.payload?.total;
    const textButton =
      totalAssets > 0
        ? translateFn('View all ({totalAssets})', {
            totalAssets,
          })
        : null;
    return html`
      <gz-easm-generic-top-data
        .rowsData=${rowData}
        .numberOfRowsToDisplay=${numberOfObjectsDisplayed}
        .numberOfRowsAvailable=${numberOfObjectsDisplayed}
        .minNumberOfRowsToDisplay=${MIN_NUMBER_OF_ROWS_TO_DISPLAY}
        .buttonText=${textButton}
        .navigateToSmartViewId=${this.payload?.inventorySmartViewId}
        .filterType="${FilterType.FINDING_NAME}"
        .findingType="${FindingClassType.ARTIFACT}"
      >
      </gz-easm-generic-top-data>
    `;
  }

  protected handleResize(): void {
    super.handleResize();

    handleWidgetWithTopDataResize.call(this);
  }
}
